import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b68c59bc = () => interopDefault(import('../../../src/pages/~social/index.vue' /* webpackChunkName: "pages/~social/index" */))
const _5321bb5f = () => interopDefault(import('../../../src/pages/~store.vue' /* webpackChunkName: "pages/~store" */))
const _7059f0be = () => interopDefault(import('../../../src/pages/account.vue' /* webpackChunkName: "pages/account" */))
const _456cd032 = () => interopDefault(import('../../../src/pages/bsg-terms-and-conditions.vue' /* webpackChunkName: "pages/bsg-terms-and-conditions" */))
const _1e754616 = () => interopDefault(import('../../../src/pages/contact-support.vue' /* webpackChunkName: "pages/contact-support" */))
const _bebc63d0 = () => interopDefault(import('../../../src/pages/create-account.vue' /* webpackChunkName: "pages/create-account" */))
const _635405c3 = () => interopDefault(import('../../../src/pages/distribution/index.vue' /* webpackChunkName: "pages/distribution/index" */))
const _9489c790 = () => interopDefault(import('../../../src/pages/environmentalimpact.vue' /* webpackChunkName: "pages/environmentalimpact" */))
const _20c2d5a2 = () => interopDefault(import('../../../src/pages/get-gala.vue' /* webpackChunkName: "pages/get-gala" */))
const _6c376327 = () => interopDefault(import('../../../src/pages/hiring-privacy-policy.vue' /* webpackChunkName: "pages/hiring-privacy-policy" */))
const _e211fbb4 = () => interopDefault(import('../../../src/pages/launcher-eula.vue' /* webpackChunkName: "pages/launcher-eula" */))
const _12797363 = () => interopDefault(import('../../../src/pages/loggedin.vue' /* webpackChunkName: "pages/loggedin" */))
const _0be9d446 = () => interopDefault(import('../../../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _7b3e8516 = () => interopDefault(import('../../../src/pages/my-collection/index.vue' /* webpackChunkName: "pages/my-collection/index" */))
const _8d71299e = () => interopDefault(import('../../../src/pages/my-wallet/index.vue' /* webpackChunkName: "pages/my-wallet/index" */))
const _5913abe8 = () => interopDefault(import('../../../src/pages/nodes/index.vue' /* webpackChunkName: "pages/nodes/index" */))
const _8db27048 = () => interopDefault(import('../../../src/pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _1fcdfe2e = () => interopDefault(import('../../../src/pages/pkce-callback.vue' /* webpackChunkName: "pages/pkce-callback" */))
const _fdbded5a = () => interopDefault(import('../../../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _1f22f958 = () => interopDefault(import('../../../src/pages/redeem.vue' /* webpackChunkName: "pages/redeem" */))
const _e3534c42 = () => interopDefault(import('../../../src/pages/register.vue' /* webpackChunkName: "pages/register" */))
const _d89cda58 = () => interopDefault(import('../../../src/pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _2c86f630 = () => interopDefault(import('../../../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _27b1e1b0 = () => interopDefault(import('../../../src/pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _26408810 = () => interopDefault(import('../../../src/pages/upgrade.vue' /* webpackChunkName: "pages/upgrade" */))
const _53058804 = () => interopDefault(import('../../../src/pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _3e09ae6f = () => interopDefault(import('../../../src/pages/verify-ip.vue' /* webpackChunkName: "pages/verify-ip" */))
const _bf86e736 = () => interopDefault(import('../../../src/pages/~social/friends.vue' /* webpackChunkName: "pages/~social/friends" */))
const _489bc18a = () => interopDefault(import('../../../src/pages/collections/~index.vue' /* webpackChunkName: "pages/collections/~index" */))
const _bd58dff8 = () => interopDefault(import('../../../src/pages/connectedAccounts/epic/index.vue' /* webpackChunkName: "pages/connectedAccounts/epic/index" */))
const _9433e44a = () => interopDefault(import('../../../src/pages/external/register.vue' /* webpackChunkName: "pages/external/register" */))
const _0a80e2a2 = () => interopDefault(import('../../../src/pages/nodes/~buy.vue' /* webpackChunkName: "pages/nodes/~buy" */))
const _353d25c8 = () => interopDefault(import('../../../src/pages/nodes/~ecosystem.vue' /* webpackChunkName: "pages/nodes/~ecosystem" */))
const _797101fc = () => interopDefault(import('../../../src/pages/nodes/~headless-linux-install.vue' /* webpackChunkName: "pages/nodes/~headless-linux-install" */))
const _20a99be4 = () => interopDefault(import('../../../src/pages/nodes/~my-nodes.vue' /* webpackChunkName: "pages/nodes/~my-nodes" */))
const _27c14134 = () => interopDefault(import('../../../src/pages/nodes/~splinternode/index.vue' /* webpackChunkName: "pages/nodes/~splinternode/index" */))
const _fe706ece = () => interopDefault(import('../../../src/pages/nodes/my-node.vue' /* webpackChunkName: "pages/nodes/my-node" */))
const _314eecc0 = () => interopDefault(import('../../../src/pages/simplex/order-history.vue' /* webpackChunkName: "pages/simplex/order-history" */))
const _39ca79af = () => interopDefault(import('../../../src/pages/my-collection/nfts/item.vue' /* webpackChunkName: "pages/my-collection/nfts/item" */))
const _64392f9b = () => interopDefault(import('../../../src/pages/collections/buy-item/_id.vue' /* webpackChunkName: "pages/collections/buy-item/_id" */))
const _2409ef71 = () => interopDefault(import('../../../src/pages/my-collection/nfts/_category.vue' /* webpackChunkName: "pages/my-collection/nfts/_category" */))
const _35654d0a = () => interopDefault(import('../../../src/pages/my-collection/_symbol.vue' /* webpackChunkName: "pages/my-collection/_symbol" */))
const _7695b654 = () => interopDefault(import('../../../src/pages/my-wallet/_symbol.vue' /* webpackChunkName: "pages/my-wallet/_symbol" */))
const _352fdfae = () => interopDefault(import('../../../src/pages/play/_content.vue' /* webpackChunkName: "pages/play/_content" */))
const _7c822918 = () => interopDefault(import('../../../src/pages/collections/_name/~crafted-item.vue' /* webpackChunkName: "pages/collections/_name/~crafted-item" */))
const _c94cca62 = () => interopDefault(import('../../../src/pages/collections/_name/~index.vue' /* webpackChunkName: "pages/collections/_name/~index" */))
const _0be66ae1 = () => interopDefault(import('../../../src/pages/collections/_name/your-items.vue' /* webpackChunkName: "pages/collections/_name/your-items" */))
const _32e90212 = () => interopDefault(import('../../../src/pages/nodes/_name/buy.vue' /* webpackChunkName: "pages/nodes/_name/buy" */))
const _306372c6 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7c5bd79c = () => interopDefault(import('../../../src/pages/_schema/_slug/index.vue' /* webpackChunkName: "pages/_schema/_slug/index" */))
const _0a14062c = () => interopDefault(import('../../../src/pages/_schema/_slug/create-account.vue' /* webpackChunkName: "pages/_schema/_slug/create-account" */))
const _30171ee8 = () => interopDefault(import('../../../src/pages/_schema/_slug/signup.vue' /* webpackChunkName: "pages/_schema/_slug/signup" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/~social",
    component: _b68c59bc,
    name: "~social"
  }, {
    path: "/~store",
    component: _5321bb5f,
    name: "~store"
  }, {
    path: "/account",
    component: _7059f0be,
    name: "account"
  }, {
    path: "/bsg-terms-and-conditions",
    component: _456cd032,
    name: "bsg-terms-and-conditions"
  }, {
    path: "/contact-support",
    component: _1e754616,
    name: "contact-support"
  }, {
    path: "/create-account",
    component: _bebc63d0,
    alias: "/create-account/*",
    name: "create-account"
  }, {
    path: "/distribution",
    component: _635405c3,
    name: "distribution"
  }, {
    path: "/environmentalimpact",
    component: _9489c790,
    name: "environmentalimpact"
  }, {
    path: "/get-gala",
    component: _20c2d5a2,
    name: "get-gala"
  }, {
    path: "/hiring-privacy-policy",
    component: _6c376327,
    name: "hiring-privacy-policy"
  }, {
    path: "/launcher-eula",
    component: _e211fbb4,
    name: "launcher-eula"
  }, {
    path: "/loggedin",
    component: _12797363,
    name: "loggedin"
  }, {
    path: "/login",
    component: _0be9d446,
    name: "login"
  }, {
    path: "/my-collection",
    component: _7b3e8516,
    name: "my-collection"
  }, {
    path: "/my-wallet",
    component: _8d71299e,
    name: "my-wallet"
  }, {
    path: "/nodes",
    component: _5913abe8,
    name: "nodes"
  }, {
    path: "/notifications",
    component: _8db27048,
    name: "notifications"
  }, {
    path: "/pkce-callback",
    component: _1fcdfe2e,
    name: "pkce-callback"
  }, {
    path: "/privacy-policy",
    component: _fdbded5a,
    name: "privacy-policy"
  }, {
    path: "/redeem",
    component: _1f22f958,
    name: "redeem"
  }, {
    path: "/register",
    component: _e3534c42,
    name: "register"
  }, {
    path: "/signup",
    component: _d89cda58,
    alias: "/signup/*",
    name: "signup"
  }, {
    path: "/terms-and-conditions",
    component: _2c86f630,
    name: "terms-and-conditions"
  }, {
    path: "/thank-you",
    component: _27b1e1b0,
    name: "thank-you"
  }, {
    path: "/upgrade",
    component: _26408810,
    name: "upgrade"
  }, {
    path: "/verify-email",
    component: _53058804,
    name: "verify-email"
  }, {
    path: "/verify-ip",
    component: _3e09ae6f,
    name: "verify-ip"
  }, {
    path: "/~social/friends",
    component: _bf86e736,
    name: "~social-friends"
  }, {
    path: "/collections/~index",
    component: _489bc18a,
    name: "collections-~index"
  }, {
    path: "/connectedAccounts/epic",
    component: _bd58dff8,
    name: "connectedAccounts-epic"
  }, {
    path: "/external/register",
    component: _9433e44a,
    name: "external-register"
  }, {
    path: "/nodes/~buy",
    component: _0a80e2a2,
    name: "nodes-~buy"
  }, {
    path: "/nodes/~ecosystem",
    component: _353d25c8,
    name: "nodes-~ecosystem"
  }, {
    path: "/nodes/~headless-linux-install",
    component: _797101fc,
    name: "nodes-~headless-linux-install"
  }, {
    path: "/nodes/~my-nodes",
    component: _20a99be4,
    name: "nodes-~my-nodes"
  }, {
    path: "/nodes/~splinternode",
    component: _27c14134,
    name: "nodes-~splinternode"
  }, {
    path: "/nodes/my-node",
    component: _fe706ece,
    name: "nodes-my-node"
  }, {
    path: "/simplex/order-history",
    component: _314eecc0,
    name: "simplex-order-history"
  }, {
    path: "/my-collection/nfts/item",
    component: _39ca79af,
    name: "my-collection-nfts-item"
  }, {
    path: "/collections/buy-item/:id?",
    component: _64392f9b,
    name: "collections-buy-item-id"
  }, {
    path: "/my-collection/nfts/:category",
    component: _2409ef71,
    name: "my-collection-nfts-category"
  }, {
    path: "/my-collection/:symbol?",
    component: _35654d0a,
    name: "my-collection-symbol"
  }, {
    path: "/my-wallet/:symbol?",
    component: _7695b654,
    name: "my-wallet-symbol"
  }, {
    path: "/play/:content?",
    component: _352fdfae,
    name: "play-content"
  }, {
    path: "/collections/:name?/~crafted-item",
    component: _7c822918,
    name: "collections-name-~crafted-item"
  }, {
    path: "/collections/:name?/~index",
    component: _c94cca62,
    name: "collections-name-~index"
  }, {
    path: "/collections/:name?/your-items",
    component: _0be66ae1,
    name: "collections-name-your-items"
  }, {
    path: "/nodes/:name/buy",
    component: _32e90212,
    name: "nodes-name-buy"
  }, {
    path: "/",
    component: _306372c6,
    name: "index"
  }, {
    path: "/:schema/:slug",
    component: _7c5bd79c,
    name: "schema-slug"
  }, {
    path: "/:schema/:slug?/create-account",
    component: _0a14062c,
    alias: "/:schema/:slug?/create-account/*",
    name: "schema-slug-create-account"
  }, {
    path: "/:schema/:slug?/signup",
    component: _30171ee8,
    alias: "/:schema/:slug?/signup/*",
    name: "schema-slug-signup"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
